<template>
  <div class="notifi-no-aptos-card">
    <div class="dialog-header">
      <p-button
        class="notifi-header-button"
        icon="pi pi-times"
        @click="handleClose"
      />
    </div>
    <div class="content-container">
      You need to have several APTs on your balance before using Notifi
    </div>
  </div>
</template>

<script lang="ts" setup>
const emit = defineEmits(['onClose']);

const handleClose = () => {
  emit('onClose');
};
</script>
<style lang="scss" scoped>
.notifi-no-aptos-card {
  height: 500px;
  display: flex;
  flex-direction: column;
}
.dialog-header {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  padding: 8px 24px 0px 24px;
}

.content-container {
  flex-grow: 1;
  text-align: center;
  justify-content: flex-start;
  align-items: center;
  display: flex;
  padding: 80px 48px 0px 48px;
  flex-direction: column;
}
</style>
